import { CONFIG } from "@/consts/config";
import { PropsWithChildren } from "react";
import { userManager } from "@/layouts/OidcProtectedLayout";
import SchemaMismatchError from "@/components/SchemaMismatchError";
import { OidcApolloProvider as SharedOidcApolloProvider } from "@lytra/frontend-common";

interface OidcApolloProviderProps extends PropsWithChildren {
  token?: string;
  impersonateTenantId?: string;
  onTenantNotLicensed?: () => void;
}

/**
 * Venus-specific Apollo Provider wrapper.
 * Uses the shared OidcApolloProvider with Venus-specific configuration.
 */
export default function OidcApolloProvider({
  children,
  token,
  impersonateTenantId,
  onTenantNotLicensed,
}: OidcApolloProviderProps) {
  return (
    <SharedOidcApolloProvider
      token={token}
      impersonateTenantId={impersonateTenantId}
      config={{
        httpLink: CONFIG.httpLink,
        wsLink: CONFIG.wsLink,
        logPrefix: "Venus",
      }}
      authErrorOptions={{
        onTokenRefresh: () => userManager.signinSilent(),
        onTokenRefreshFailed: () => {
          userManager.removeUser().then(() => {
            console.log("Venus Apollo errorLink - User removed, reloading page");
            window.location.reload();
          }).catch(() => {
            window.location.reload();
          });
        },
        onTenantNotLicensed,
      }}
      SchemaMismatchErrorComponent={SchemaMismatchError}
    >
      {children}
    </SharedOidcApolloProvider>
  );
}
